import { apiBusSchedBaseURL } from '../../authentication/Global';
import { apiSchematicMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class DownloadFileAPI {
    constructor(appName) {
        switch (appName) {
            case "bussched":
                this.baseUrl = new URL("bussched/layouts/", apiBusSchedBaseURL);
                break;
            case "schematicmap":
                this.baseUrl = new URL("schematicmap/layouts/", apiSchematicMapBaseURL);
                break;
            default:
                this.baseUrl = new URL("");
                break;
        }
    }

    downloadLayout(layoutId) {
        return API.authenticatedRequest({
            url: new URL(`export/${layoutId}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        }, false);
    }
}
